import { FC, PropsWithChildren } from 'react';
import { useMount } from 'react-use';

import { useGetBootstrap } from '@helpful/network';
import { useSplash } from '@native/splash';

import { DataContext } from '../../../contexts/Data.context';

type DataProps = PropsWithChildren<{}>;

export const Data: FC<DataProps> = ({ children }) => {
  const { hide } = useSplash();

  const { data, isSuccess, refetch } = useGetBootstrap({
    query: {
      enabled: false,
    },
  });

  data?.surveys.forEach(({ icon }) => {
    new Image().src = icon;
  });

  data?.tours.forEach(({ image }) => {
    new Image().src = image;
  });

  useMount(async () => {
    await refetch();
    hide();
  });

  if (!isSuccess) return null;

  return (
    <DataContext.Provider
      value={{
        ...data,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
